import { SITE_ORIGIN } from '../config/site';

/** Normalize route or pages.json key to a pathname (no query/hash). */
export function toCanonicalPath(path: string): string {
  if (!path || path === 'home') {
    return '/';
  }
  const withLeadingSlash = path.startsWith('/') ? path : `/${path}`;
  if (withLeadingSlash !== '/' && withLeadingSlash.endsWith('/')) {
    return withLeadingSlash.slice(0, -1);
  }
  return withLeadingSlash;
}

export function buildCanonicalUrl(path: string): string {
  const pathname = toCanonicalPath(path);
  return pathname === '/' ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${pathname}`;
}
